export default __webpack_public_path__ + "static/media/nie-login-logo.0b9fa240.jpg";